import React from "react";

const CompaniesComponent = () => {
  return (
    <section className="flex flex-col px-10 md:px-0 py-10 md:py-20  font-urbanist gap-10 ">
      <div className=" flex flex-col h-[110vh] md:h-full md:flex-row gap-20 md:gap-0 md:justify-evenly">
        <div className="w-full md:w-fit flex flex-col gap-10 items-start">
          <img
            className="h-12 w-auto"
            loading="eager"
            alt=""
            src="/new/AWENI_DISTRIBUTION_Logo.svg"
          />
          <h3 className="max-w-sm text-4xl">AWENI DISTRIBUTION</h3>
          <p className="max-w-md">
            {
              "AWENI DISTRIBUTION est la filiale de STRACA BENIN SA dédiée à la commercialisation nationale de divers produits, allant des camions FAW et MAN aux lubrifiants HAFA, en passant par les pneumatiques AEOLUS, les filtres UFI, les pièces détachées PACK, ainsi que les batteries MUTLU et BOSCH. Son rôle clé est d'assurer une distribution efficace auprès des détaillants et grossistes afin de garantir la disponibilité continue des produits et de préserver la compétitivité sur le marché."
            }
          </p>
          {/*          <button className="w-fit py-3 px-7 bg-white text-main-color rounded-xl shadow-xl">
            En savoir plus
          </button>*/}
        </div>
        <div className="w-full md:w-[30vw] relative flex justify-center">
          <div className=" absolute inset-0 bg-sandybrown w-[85vw] md:w-[27.5vw] h-[45vh] rounded-xl" />
          <img
            className="absolute inset-0 -top-5 left-10 w-[65vw]  md:w-[22.5vw] h-[50vh] object-cover rounded-xl z-[1]"
            loading="eager"
            alt=""
            src="/oil-1.png"
          />
        </div>
      </div>
      <div className=" md:py-48 flex flex-col h-[110vh] md:h-full md:flex-row gap-20 md:gap-0 md:justify-evenly">
        <div className="w-full md:w-[30vw] relative flex justify-center top-[50vh] md:top-0">
          <div className="absolute inset-0 bg-main-color w-[85vw] md:w-[27.5vw] h-[45vh] rounded-xl" />
          <img
            className="absolute inset-0 -top-5 left-10 w-[65vw]  md:w-[22.5vw] h-[50vh] object-cover rounded-xl z-[1]"
            loading="eager"
            alt=""
            src="/transit-1.png"
          />
        </div>
        <div className="w-full md:w-fit flex flex-col items-end gap-10">
          <img
            className="h-12 w-auto"
            loading="eager"
            alt=""
            src="/new/AWENI_SERVICES_Logo.svg"
          />
          <h3 className="max-w-sm text-4xl text-end">AWENI SERVICES</h3>
          <p className="max-w-md text-end">
            {
              "Spécialisé dans la maintenance, l'entretien et la réparation des camions. Nos techniciens qualifiés et nos installations modernes garantissent des services de réparation rapides et efficaces, assurant la longévité et la performance optimale de vos véhicules."
            }
          </p>
          {/*          <button className="w-fit py-3 px-7 bg-white text-main-color rounded-xl shadow-xl">
            En savoir plus
          </button>*/}
        </div>
      </div>
      <div className="md:py-48 flex flex-col h-[110vh] md:h-full md:flex-row gap-20 md:gap-0 md:justify-evenly">
        <div className="w-full md:w-fit flex flex-col gap-10 items-start">
          <img
            className="h-12 w-auto"
            loading="eager"
            alt=""
            src="/new/AWENI_BTP_Logo.svg"
          />
          <h3 className="max-w-sm text-4xl">AWENI BTP</h3>
          <p className="max-w-md">
            {"Des équipements innovants pour des projets d'extraction réussis.\n" +
              "Pour tous vos besoins en exploitation de carrières, AWENI BTP met à disposition des machines et des équipements de pointe. Nous assurons la disponibilité des meilleurs engins pour vos projets d'extraction, vous offrant ainsi des solutions adaptées et efficaces. "}
          </p>
          {/*          <button className="mt-auto w-fit py-3 px-7 bg-white text-main-color rounded-xl shadow-xl">
            En savoir plus
          </button>*/}
        </div>
        <div className="w-full md:w-[30vw] relative flex justify-center">
          <div className=" absolute inset-0 bg-[#099d7e] w-[85vw] md:w-[27.5vw] h-[45vh] rounded-xl" />
          <img
            className="absolute inset-0 -top-5 left-10 w-[65vw]  md:w-[22.5vw] h-[50vh] object-cover rounded-xl z-[1]"
            loading="eager"
            alt=""
            src="/aweni-1.png"
          />
        </div>
      </div>
    </section>
  );
};

export default CompaniesComponent;
